(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klayd-purchase-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('klayd-purchase-guide')) {
    customElements.define('klayd-purchase-guide', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        this.content = this.closest('.product__content');
        if (!this.root || !this.content) return;
        this.choose = this.querySelector('[data-klayd-choose]');
        this.sticky = this.querySelector('[data-klayd-sticky]');
        this.stickyButton = this.querySelector('[data-klayd-sticky-button]');
        this.chosen = this.content.classList.contains('unload');
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.choose.addEventListener('click', () => this.focusSizes(), options);
        this.stickyButton.addEventListener('click', () => this.activate(), options);
        this.root.addEventListener('click', event => {
          const label = event.target.closest('.klayd-size-choice label');
          if (label || event.target.matches('[data-klayd-size-input]')) {
            this.chosen = true; this.content.classList.add('unload'); this.schedule();
          }
        }, {...options, capture:true});
        this.root.addEventListener('change', event => {
          if (event.target.matches('[data-klayd-size-input]')) {
            this.chosen = true;
            this.content.classList.add('unload');
            this.sync();
          }
        }, {...options, capture:true});
        this.root.addEventListener('submit', event => {
          if (event.target.matches('[data-product-form]') && this.needsChoice()) {
            event.preventDefault(); event.stopImmediatePropagation(); this.focusSizes();
          }
        }, {...options, capture:true});
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.content, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled','aria-disabled']});
        window.addEventListener('scroll', () => this.visibility(), {...options, passive:true});
        window.addEventListener('resize', () => this.visibility(), options);
        this.sync();
      }
      disconnectedCallback() {
        this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      }
      needsChoice() { return !!this.root.querySelector('[data-klayd-size-input]') && !this.chosen; }
      schedule() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.sync()); }
      setText(element, text) { if (element && element.textContent !== text) element.textContent = text; }
      sync() {
        this.main = this.content.querySelector('[data-add-to-cart]');
        const needed = this.needsChoice();
        this.content.dataset.klaydChoice = needed ? 'needed' : 'chosen';
        this.choose.hidden = !needed;
        const selected = this.root.querySelector('[data-klayd-size-input]:checked');
        let variant;
        try { variant = JSON.parse(this.root.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch (_) {}
        this.soldOut = variant?.available === false;
        // The Shopify section response must match the radio before enabling a sticky purchase.
        const matched = !selected || variant?.options?.includes(selected.value);
        this.pending = !matched || (!this.soldOut && (!!this.main?.disabled || this.main?.getAttribute('aria-disabled') === 'true'));
        this.content.classList.toggle('klayd-has-restock', this.soldOut && !!this.content.querySelector('.restock-rocket-button'));
        this.stickyButton.disabled = !needed && this.pending;
        this.setText(this.stickyButton, needed ? this.dataset.choose : this.soldOut ? this.dataset.notify : this.dataset.add);
        this.setText(this.querySelector('[data-klayd-sticky-size]'), needed ? this.dataset.choose : selected?.value.split(' (')[0] || '');
        const price = this.content.querySelector('.price--on-sale .price-item--sale') || this.content.querySelector('.price__regular .price-item--regular') || this.content.querySelector('[data-product-price]');
        this.setText(this.querySelector('[data-klayd-sticky-price]'), price?.textContent.trim() || '');
        if (this.dataset.country === 'US' && this.dataset.currency === 'USD' && variant) {
          this.setText(this.querySelector('[data-klayd-shipping]'), variant.price >= 8500 ? this.dataset.free : this.dataset.shipping);
        }
        if (!needed && !this.soldOut && this.main && !this.main.disabled) {
          const text = this.main.querySelector('[data-add-to-cart-text]');
          if (text && this.main.dataset.preorder !== 'true') this.setText(text, this.dataset.add);
        }
        this.visibility();
      }
      focusSizes() {
        const sizes = this.root.querySelector('[data-klayd-size-buttons]');
        sizes?.scrollIntoView({behavior:'smooth',block:'center'});
        const input = sizes?.querySelector('input:checked') || sizes?.querySelector('input');
        input?.focus({preventScroll:true});
      }
      activate() {
        if (this.needsChoice()) return this.focusSizes();
        if (this.pending) return;
        if (this.soldOut) {
          const notify = [...this.content.querySelectorAll('button,a')].find(el => !this.contains(el) && /notify/i.test(el.textContent) && el.getBoundingClientRect().height > 0);
          if (notify) notify.click();
          else this.main?.scrollIntoView({behavior:'smooth',block:'center'});
          return;
        }
        this.main?.click();
      }
      visibility() {
        const target = this.needsChoice() ? this.choose : this.soldOut ? (this.content.querySelector('.restock-rocket-button') || this.main) : this.main;
        if (!target) return;
        this.sticky.hidden = target.getBoundingClientRect().bottom >= 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
